import { useState } from "react";
import { OtherUtil } from "utils/other";
import { useLoading } from "./useLoading";

export const useHandleSubmitApi = <
  T extends (...args: any[]) => Promise<any>
  // E extends (...errors: any[]) => Promise<any>
>(
  callback: T,
  callbackError?: () => void
) => {
  const [loading, startLoading, stopLoading] = useLoading();
  const [isError, setIsError] = useState(false);

  const handleSubmitApi = async (...args: [...Parameters<T>, ...any[]]) => {
    // const callbackArgs = args.slice(0, args.length - 1) as Parameters<T>;
    // const errors = args[args.length - 1] as any[];
    try {
      startLoading();
      return await callback(...args);
    } catch (error) {
      console.log(22, error);
      if (callbackError) {
        await callbackError();
      }
      OtherUtil.loadError(error);
      setIsError(true);
    } finally {
      stopLoading();
    }
  };
  return [handleSubmitApi, loading, isError] as const;
};
